import type { User } from 'firebase/auth';
import { createContext } from 'react';
import { UserProfile, UserSettings } from '@/types';

interface UserContextValue {
  user: User | null;
  currentUser: UserProfile | null;
  settings: UserSettings | null;
  isAdmin: boolean;
}

export const UserContext = createContext<UserContextValue | undefined>(undefined);
